export const updateOne = <T>(key: keyof T) => (items: T[], item: T) => {
  return items.map((t) => {
    if (t[key] === item[key]) {
      return item;
    }
    return t;
  });
};

export const removeBy = <T>(key: keyof T) => (items: T[], item: T) => {
  return items.filter((t) => t[key] !== item[key]);
};

export const updateMany = <T>(key: keyof T) => (items1: T[], items2: T[]) => {
  // index both , replace
  return Object.values(
    [...items1, ...items2]
      .map((t) => [t[key], t])
      .reduce((acc, item) => {
        const [k, v] = item;
        //@ts-ignore
        acc[k] = v;
        return acc;
      }, {})
  );
};

export const addToArray = <T>(arr1: T[], arr2: T[]) => [...arr1, ...arr2];

export const setArr = <T>(items: T[], val: T[]) => val;

export const sortBy = <T, S extends keyof T>(
  arr: T[],
  by: S,
  asc: boolean
): T[] => {
  const keys = arr.map((a) => a[by]).sort();
  const copy = [...arr];

  const sortedArr: T[] = keys.map((key) => {
    const index = copy.findIndex((item) => item[by] === key);
    const [item] = copy.splice(index, 1);
    return item;
  });

  return asc ? sortedArr.reverse() : sortedArr;
};

export const indexBy = <T>(prop: keyof T) => (arr: T[]) =>
  arr.reduce((acc, t) => {
    // @ts-ignore
    acc[t[prop]] = t;
    return acc;
  }, {} as { [key: string]: T });

export const toggleAll = <T>(prop: keyof T) => (arr: T[], isOn: boolean) => {
  return arr.map((t) => {
    return {
      ...t,
      [prop]: isOn,
    };
  });
};
